import styled, { css } from 'styled-components'
import { ProductsContainer, Icon, ImageContainer } from './types'
import { createCSSObject } from '../../../helpers/theming/utilities'

const buttonContainerStyle = css`
  border-top: 1px solid ${(props) => props.theme.color.monochrome.light};
  padding: 15px;
  margin: 0 -15px;
  margin-top: ${(props) => props.theme.size.spacing.md};
`

const iconStyle = (isSains) =>
  css`
    path {
      fill: ${(props) => (isSains ? props.theme.color.monochrome.white : props.theme.color.monochrome.dark)};
    }
  `

export const StyledDrawerContent = styled.div`
  display: grid;

  @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].sm}) {
    align-items: center;
    grid-template-columns: 1fr 1fr;
    grid-auto-flow: column;
    column-gap: ${(props) => props.theme.size.spacing.lg};
  }

  @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].sm}) and (max-width: ${(props) =>
      props.theme.size.breakpoint['max-width'].md}) {
    grid-template-columns: 1fr 1.1fr;
  }
`
export const StyledDrawerImageContainer = styled.div<ImageContainer>`
  img {
    width: 100%;
    max-height: 470px;
    aspect-ratio: 4 / 5;
    ${(props) =>
      props.isSains &&
      css`
        aspect-ratio: 2 / 3;
        @media screen and (max-width: ${props.theme.size.breakpoint['max-width'].sm}) {
          aspect-ratio: 1 / 1;
        }
      `}
  }
`

export const StyledChevronButton = styled.button`
  all: unset;
  display: inline;
  :focus {
    outline: 5px auto -webkit-focus-ring-color;
  }
`
export const StyledChevronContainer = styled.div<Icon>`
  ${iconStyle(false)}
  position: absolute;
  top: 215px;

  @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].sm}) {
    top: 230px;
  }

  ${(props) =>
    props.dir === 'left'
      ? css`
          margin-left: ${props.theme.size.spacing.md};
        `
      : css`
          right: 7%;

          @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].md}) {
            left: ${props.isSains ? '89%' : '41%'};
          }

          @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].lg}) {
            left: ${props.isSains ? '89%' : '44.5%'};
          }
        `}

  svg {
    background-color: ${(props) => props.theme.color.monochrome.white};
    border-radius: 50%;
    padding: ${(props) => props.theme.size.spacing.sm};
    cursor: pointer;
  }
`

export const StyledImageLabel = styled.div`
  display: flex;
  justify-content: space-between;
`

export const StyledButtonContainer = styled.div`
  ${buttonContainerStyle}
  display: none;

  @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].sm}) {
    display: block;
  }
`

export const StyledButtonContainerMobile = styled.div`
  ${buttonContainerStyle}

  display: block;
  margin-bottom: ${(props) => props.theme.size.spacing.lg};

  @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].sm}) {
    display: none;
  }
`
export const StyledProductContainer = styled.div<ProductsContainer>`
  overflow-x: hidden;
  overflow-y: auto;
  scroll-snap-type: y mandatory;
  // This is to make the product card scroller always visible so it is clear that it is scrollable
  ::-webkit-scrollbar {
    width: 7px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 0.5);
    box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
  }
  max-height: 500px;
  ${(props) =>
    !props.isError &&
    css`
      align-self: flex-start;
    `};
  @media screen and (max-width: ${(props) => props.theme.size.breakpoint['max-width'].md}) {
    max-height: 440px;
  }
`

export const StyledProductCardContainer = styled.div`
  display: flex;
`

export const StyledNoProducts = styled.div`
  text-align: center;

  @media screen and (max-width: ${(props) => props.theme.size.breakpoint['max-width'].sm}) {
    margin-top: 35%;
  }
`

export const StyledProductCardGrid = styled.div<ProductsContainer>`
  ${(props) =>
    !props.isError &&
    css`
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-auto-flow: row;
      column-gap: ${props.theme.size.spacing.md};
    `};
`

export const StyledProductsHeader = styled.h5`
  font-weight: bold;
`
// GOL Variant styled components

export const StyledDrawerHeadingContainer = styled.div`
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: space-between;
  width: 100%;
  margin-top: ${(props) => props.theme.size.spacing.md};
  :hover {
    path {
      fill: ${(props) => props.theme.color.palette['brand-1']};
    }
  }
`

export const StyledDateLabel = styled.label`
  ${(props) => createCSSObject(props.theme.font.stack['label-1'])};
  font-weight: normal;
  color: ${(props) => props.theme.color.palette['brand-3']};
`
export const StyledDescriptionContainer = styled.div`
  padding-top: ${(props) => props.theme.size.spacing.xl};
  white-space: pre-wrap;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 50%;
`
